function getSizeClass(size) {
    let sizeClass = '';
    switch (size) {
        case 'xxs':
            sizeClass = 'badge--circle-xxs';
            break;
        case 'xs':
            sizeClass = 'badge--circle-xs';
            break;
        case 'sm':
            sizeClass = 'badge--circle-sm';
            break;
        case 'md':
            sizeClass = 'badge--circle-md';
            break;
        case 'md-lg':
            sizeClass = 'badge--circle-md-lg';
            break;
        case 'lg':
            sizeClass = 'badge--circle-lg';
            break;
        case 'xlg':
            sizeClass = 'badge--circle-xlg';
            break;
    }

    return sizeClass;
}

function getKindClass(kind) {
    return !!kind ? 'badge--' + kind : null;
}

class BadgeController {
    constructor() {
        this.$onInit = function() {
            this.classes = [];

            const sizeClass = getSizeClass(this.size);
            const kindClass = getKindClass(this.kind);

            if (!!sizeClass) {
                this.classes.push(sizeClass);
            }

            if (!!kindClass) {
                this.classes.push(kindClass);
            }
        };
    }
}

module.exports = BadgeController;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/badge-controller.js
 **/